import chroma from 'chroma-js'

const offBlack = '#101010'
const offWhite = '#f0f0f0'
const whiteLum = chroma(offWhite).luminance()
const blackLum = chroma(offBlack).luminance()

export function getForegroundColor(backgroundColor) {
  /* See stackoverflow: https://ux.stackexchange.com/a/107319 */
  try {
    const colorLum = chroma(backgroundColor).luminance()
    const whiteLumRatio = (whiteLum + 0.05) / (colorLum + 0.05)
    const blackLumRatio = (colorLum + 0.05) / (blackLum + 0.05)
    return whiteLumRatio < blackLumRatio ? offBlack : offWhite
  } catch (e) {
    return offBlack
  }
}
